import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const LEVELS = [
  ['loisir', 'Loisir'],
  ['departemental', 'Dép.'],
  ['regional', 'Régio.'],
  ['national', 'Nat.'],
  ['pro', 'Pro'],
];

// Écran obligatoire après une 1re connexion Google : Google ne fournit ni genre, ni niveau,
// ni date de naissance, or ces champs conditionnent l'éligibilité aux catégories.
function CompleteProfile({ user, onUserUpdate }) {
  const [gender, setGender]       = useState('');
  const [level, setLevel]         = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!gender) return setError('Sélectionne ton genre.');
    if (!level) return setError('Sélectionne ton niveau.');
    setLoading(true);
    try {
      const res = await axios.put(`${API_URL}/api/auth/profile`, {
        firstName: user.firstName, lastName: user.lastName, email: user.email,
        gender, level, birthdate: birthdate || null,
      }, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      onUserUpdate?.(res.data.user);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la mise à jour');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="screen" style={{ background: 'var(--ink)', minHeight: '100vh' }}>
      <div style={{ height: 54 }} />
      <div style={{ padding: '4px 20px 12px', flexShrink: 0, borderBottom: '1px solid var(--line)' }}>
        <div className="display" style={{ fontSize: 18, textAlign: 'center' }}>Encore une étape</div>
      </div>

      <div style={{ overflowY: 'auto', paddingBottom: 120 }}>
        <p style={{ padding: '20px 20px 0', color: 'var(--text-2)', fontSize: 14, lineHeight: 1.5 }}>
          Ton compte Google ne nous donne pas ces infos, pourtant elles servent à vérifier ton éligibilité aux catégories des tournois.
        </p>

        {error && (
          <div style={{
            margin: '16px 20px 0', padding: '10px 14px', borderRadius: 10,
            background: 'rgba(229,80,62,0.1)', color: '#E5503E',
            fontSize: 13, fontWeight: 600, border: '1px solid rgba(229,80,62,0.25)',
          }}>{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Genre */}
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', padding: '0 20px', margin: '22px 0 12px' }}>
            <h3 style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-2)', margin: 0 }}>Genre</h3>
          </div>
          <div style={{ padding: '0 20px' }}>
            <div className="card col gap-2" style={{ padding: 14 }}>
              <div style={{ display: 'flex', gap: 8 }}>
                {[['masculin', 'Homme'], ['feminin', 'Femme']].map(([k, l]) => (
                  <button key={k} type="button" onClick={() => setGender(k)} style={{
                    flex: 1, padding: '10px 0', borderRadius: 8, fontSize: 13, fontWeight: 600,
                    background: gender === k ? 'var(--text)' : 'var(--ink-3)',
                    color: gender === k ? 'var(--ink)' : 'var(--text-2)',
                  }}>{l}</button>
                ))}
              </div>
            </div>
          </div>

          {/* Niveau */}
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', padding: '0 20px', margin: '22px 0 12px' }}>
            <h3 style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-2)', margin: 0 }}>Niveau</h3>
          </div>
          <div style={{ padding: '0 20px' }}>
            <div className="card col gap-2" style={{ padding: 14 }}>
              <div style={{ display: 'flex', gap: 6 }}>
                {LEVELS.map(([val, lbl]) => (
                  <button key={val} type="button" onClick={() => setLevel(val)} style={{
                    flex: 1, minWidth: 0, padding: '10px 0', borderRadius: 8, fontSize: 12, fontWeight: 600,
                    background: level === val ? 'var(--sun)' : 'var(--ink-3)',
                    color: level === val ? 'var(--ink)' : 'var(--text-2)',
                  }}>{lbl}</button>
                ))}
              </div>
              <span style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 2 }}>
                Modifiable plus tard. Sert à matcher partenaires et tournois.
              </span>
            </div>
          </div>

          {/* Date de naissance */}
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', padding: '0 20px', margin: '22px 0 12px' }}>
            <h3 style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-2)', margin: 0 }}>Date de naissance</h3>
          </div>
          <div style={{ padding: '0 20px' }}>
            <div className="card col gap-2" style={{ padding: 14 }}>
              <span className="mono" style={{ color: 'var(--text-3)' }}>Naissance</span>
              <input type="date" value={birthdate} onChange={e => setBirthdate(e.target.value)}
                style={{ flex: 1, background: 'transparent', border: 0, outline: 'none', minWidth: 0, color: 'var(--text)', fontSize: 14, fontFamily: 'inherit' }} />
              <span style={{ fontSize: 11, color: 'var(--text-3)', marginTop: 2 }}>
                Fortement recommandé — sert à vérifier l'âge des catégories jeunes.
              </span>
            </div>
          </div>
        </form>
      </div>

      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, padding: '12px 20px 28px',
        background: 'linear-gradient(to top, var(--ink) 70%, transparent)',
      }}>
        <button onClick={handleSubmit} disabled={loading} className="btn btn-primary"
          style={{ width: '100%', padding: '15px 20px' }}>
          {loading ? 'Enregistrement…' : 'Continuer'}
        </button>
      </div>
    </div>
  );
}

export default CompleteProfile;
